import { componentFactory } from '@dovetail/core/initialization';
import { ProjectConstructorConfig } from '@dovetail/core/types';

const exportableComponents: Record<string, () => Promise<unknown>> = {
  /* PLOP_NEW_COMPONENT */
  ProductSwitcher: () =>
    import(
      /* webpackChunkName: "ProductSwitcherComponent" */ './components/ProductSwitcher'
    ),
};

export default class ProductSwitcher {
  components: Record<string, ReturnType<typeof componentFactory>>;
  constructor(readonly config: ProjectConstructorConfig) {
    this.config = config;
    this.components = Object.keys(exportableComponents).reduce(
      (accumulator, componentName) => ({
        ...accumulator,
        [componentName]: componentFactory(
          exportableComponents[componentName],
          this.config
        ),
      }),
      {}
    );
  }
}
